/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fulfilledparticipationrequirements2Inputs */

const en__field_fulfilledparticipationrequirements2 = /** @type {(inputs: _Field_Fulfilledparticipationrequirements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participation requirements fullfiled`)
};

const de__field_fulfilledparticipationrequirements2 = /** @type {(inputs: _Field_Fulfilledparticipationrequirements2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmeanforerungen erfüllt`)
};

/**
* | output |
* | --- |
* | "Participation requirements fullfiled" |
*
* @param {_Field_Fulfilledparticipationrequirements2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_fulfilledparticipationrequirements2 = /** @type {((inputs?: _Field_Fulfilledparticipationrequirements2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fulfilledparticipationrequirements2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_fulfilledparticipationrequirements2(inputs)
	return de__field_fulfilledparticipationrequirements2(inputs)
});
export { _field_fulfilledparticipationrequirements2 as "_field_fulfilledParticipationRequirements" }